import forge from 'node-forge';

const oids = (forge.pki.oids = forge.pki.oids || {});

// password-based-encryption for KISA
oids['1.2.410.200004.1.15'] = 'pbeWithSHA1AndSEED-CBC';
oids['pbeWithSHA1AndSEED-CBC'] = '1.2.410.200004.1.15';
oids['1.2.410.200004.1.4'] = 'seed-CBC';
oids['seed-CBC'] = '1.2.410.200004.1.4';
oids['1.2.410.200004.1.4.2'] = 'GPKIpbeWithSHA1AndSEED-CBC';
oids['GPKIpbeWithSHA1AndSEED-CBC'] = '1.2.410.200004.1.4.2';

// certificatePolicies policyQualifiers
oids['1.3.6.1.5.5.7.2.1'] = 'cps';
oids['cps'] = '1.3.6.1.5.5.7.2.1';
oids['1.3.6.1.5.5.7.2.2'] = 'unotice';
oids['unotice'] = '1.3.6.1.5.5.7.2.2';

oids['1.3.6.1.5.5.7.1.1'] = 'authorityInfoAccess';
oids['authorityInfoAccess'] = '1.3.6.1.5.5.7.1.1';

// 금융결제원
oids['1.2.410.200005.1.1.1'] = '범용(개인)';
oids['1.2.410.200005.1.1.4'] = '은행/신용카드/보험(개인)';
oids['1.2.410.200005.1.1.5'] = '범용(기업)';
oids['1.2.410.200005.1.1.2'] = '은행/신용카드/보험(법인)';
oids['1.2.410.200005.1.1.6.2'] = '신용카드용';
oids['1.2.410.200005.1.1.6.8'] = '전자세금용';
oids['1.2.410.200005.1.1.6.1'] = '기업뱅킹';
oids['1.2.410.200005.1.1.8.20'] = '전자세금용(기업)';
oids['1.2.410.200005.1.1.4.8'] = '조합번호전용';
oids['1.2.410.200005.1.1.4.88'] = '조합번호전용';

//한국 무역 통신
oids['1.2.410.200012.1.1.1'] = '범용(개인)';
oids['1.2.410.200012.1.1.101'] = '은행/보험용';
oids['1.2.410.200012.1.1.105'] = '신용카드용';
oids['1.2.410.200012.1.1.3'] = '범용(법인)';
oids['1.2.410.200012.5.19.1.1'] = '전자세금용';

//한국 증권 전산
oids['1.2.410.200004.5.1.1.5'] = '범용(개인)';
oids['1.2.410.200004.5.1.1.7'] = '범용(법인)';
oids['1.2.410.200004.5.1.1.9.2'] = '신용카드용';
oids['1.2.410.200004.5.1.1.9'] = '증권/보험(개인)';
oids['1.2.410.200004.1.1.12.902'] = '전자세금용';
oids['1.2.410.200004.5.1.1.9.1'] = '은행/보험용(개인)';
oids['1.2.410.200004.5.1.1.10'] = '증권/보험용(개인)';
oids['1.2.410.200004.5.1.1.10.1'] = '은행/보험용(개인)';
oids['1.2.410.200004.5.1.1.10.2'] = '신용카드용(법인)';

//한국 정보 인증
oids['1.2.410.200004.5.2.1.2'] = '1등급 개인';
oids['1.2.410.200004.5.2.1.1'] = '1등급 법인';
oids['1.2.410.200004.5.2.1.7.1'] = '은행/신용카드용/보험용';
oids['1.2.410.200004.5.2.1.7.3'] = '신용카드용';

//한국 전자 인증
oids['1.2.410.200004.5.4.1.1'] = '범용(개인)';
oids['1.2.410.200004.5.4.1.2'] = '범용(법인)';
oids['1.2.410.200004.5.4.1.101'] = '은행/보험용';
oids['1.2.410.200004.5.4.1.103'] = '신용카드용';
oids['1.2.410.200004.5.4.2.80'] = '전자세금용';

//한국 전산원
oids['1.2.410.200004.5.3.1.1'] = '기관';
oids['1.2.410.200004.5.3.1.2'] = '법인';
oids['1.2.410.200004.5.3.1.9'] = '개인';

oids['1.2.410.200004.5.5.1.1'] = '범용(개인)';
oids['1.2.410.200004.5.5.1.2'] = '범용(기업)';
oids['1.2.410.200004.5.5.1.3.1'] = '제휴기관용(개인)';
oids['1.2.410.200004.5.5.1.4.1'] = '제휴기관용(기업)';
oids['1.2.410.200004.5.5.1.4.2'] = '전자세금용(기업)';
oids['1.2.410.200004.5.5.1.4.4'] = '이용기관용';
oids['1.2.410.200004.5.5.1.4.5'] = '특수목적용(기업)';

//GPKI
oids['1.2.410.100001.2'] = 'GPKI 인증정책';
oids['1.2.410.100001.2.1'] = '기관용';
oids['1.2.410.100001.2.1.1'] = '전자관인';
oids['1.2.410.100001.2.1.2'] = '컴퓨터용';
oids['1.2.410.100001.2.1.3'] = '특수목적용';
oids['1.2.410.100001.2.1.4'] = '공공/민간 전자관인';
oids['1.2.410.100001.2.1.5'] = '공공/민간 컴퓨터용';
oids['1.2.410.100001.2.1.6'] = '공공/민간 특수목적용';
oids['1.2.410.100001.2.2'] = '개인용';
oids['1.2.410.100001.2.2.1'] = '공무원 전자서명';
oids['1.2.410.100001.2.2.2'] = '공공/민간 개인용 전자서명';
oids['1.2.410.100001.5.3.1.1'] = '전자관인';
oids['1.2.410.100001.5.3.1.3'] = '개인용';
oids['1.2.410.100001.5.3.1.5'] = '특수목적용';
oids['1.2.410.100001.5.3.1.7'] = '컴퓨터용';
oids['1.2.410.100001.5.3.1.9'] = 'SSL용';

//undefined
oids['undefined'] = '일반인증서';

// ENGLISH Version
//금융결재원
const englishPrefix = 'ENG_';
//금융결재원
oids[englishPrefix + '1.2.410.200005.1.1.1'] = 'Public(Individual)';
oids[englishPrefix + '1.2.410.200005.1.1.4'] = 'Banking/CreditCard(Individual)';
oids[englishPrefix + '1.2.410.200005.1.1.5'] = 'Public(Enterprise)';
oids[englishPrefix + '1.2.410.200005.1.1.2'] = 'Banking/CreditCard(Corporation)';
oids[englishPrefix + '1.2.410.200005.1.1.6.2'] = 'CreditCard';
oids[englishPrefix + '1.2.410.200005.1.1.6.8'] = 'E-Tax';
oids[englishPrefix + '1.2.410.200005.1.1.6.1'] = 'Banking(Enterprise)';
oids[englishPrefix + '1.2.410.200005.1.1.8.20'] = 'E-Tax(Corporation)';
oids[englishPrefix + '1.2.410.200005.1.1.4.8'] = 'CombinationNumber';
oids[englishPrefix + '1.2.410.200005.1.1.4.88'] = 'CombinationNumber';

//한국 무역 통신
oids[englishPrefix + '1.2.410.200012.1.1.1'] = 'Public(Individual)';
oids[englishPrefix + '1.2.410.200012.1.1.101'] = 'Banking';
oids[englishPrefix + '1.2.410.200012.1.1.105'] = 'CreditCard';
oids[englishPrefix + '1.2.410.200012.1.1.3'] = 'Public(Corporation)';
oids[englishPrefix + '1.2.410.200012.5.19.1.1'] = 'E-Tax';

//한국 증권 전산
oids[englishPrefix + '1.2.410.200004.5.1.1.5'] = 'Public(Individual)';
oids[englishPrefix + '1.2.410.200004.5.1.1.7'] = 'Public(Corporation)';
oids[englishPrefix + '1.2.410.200004.5.1.1.9.2'] = 'CreditCard';
oids[englishPrefix + '1.2.410.200004.5.1.1.9'] = 'Securities(Private)';
oids[englishPrefix + '1.2.410.200004.1.1.12.902'] = 'E-Tax';
oids[englishPrefix + '1.2.410.200004.5.1.1.9.1'] = 'Bank(Private)';
oids[englishPrefix + '1.2.410.200004.5.1.1.10'] = 'Securities(Private)';
oids[englishPrefix + '1.2.410.200004.5.1.1.10.1'] = 'Bank(Private)';
oids[englishPrefix + '1.2.410.200004.5.1.1.10.2'] = 'Credit Cards(Coroporate)';

//한국 정보 인증
oids[englishPrefix + '1.2.410.200004.5.2.1.2'] = '1Class(Individual)';
oids[englishPrefix + '1.2.410.200004.5.2.1.1'] = '1Class(Corporation)';
oids[englishPrefix + '1.2.410.200004.5.2.1.7.1'] = 'Banking/CreditCard';
oids[englishPrefix + '1.2.410.200004.5.2.1.7.3'] = 'CreditCard';

//한국 전자 인증
oids[englishPrefix + '1.2.410.200004.5.4.1.1'] = 'Public(Individual)';
oids[englishPrefix + '1.2.410.200004.5.4.1.2'] = 'Public(Corporation)';
oids[englishPrefix + '1.2.410.200004.5.4.1.101'] = 'Banking';
oids[englishPrefix + '1.2.410.200004.5.4.1.103'] = 'CreditCard';
oids[englishPrefix + '1.2.410.200004.5.4.2.80'] = 'E-Tax';

//한국 전산원
oids[englishPrefix + '1.2.410.200004.5.3.1.1'] = 'Agency';
oids[englishPrefix + '1.2.410.200004.5.3.1.2'] = 'Corporation';
oids[englishPrefix + '1.2.410.200004.5.3.1.9'] = 'Individual';

//이니텍
oids[englishPrefix + '1.2.410.200004.5.5.1.1'] = 'Public(Individual)';
oids[englishPrefix + '1.2.410.200004.5.5.1.2'] = 'Public(Corporation)';
oids[englishPrefix + '1.2.410.200004.5.5.1.3.1'] = 'Alliance(Individual)';
oids[englishPrefix + '1.2.410.200004.5.5.1.4.1'] = 'Alliance(Corporation)';
oids[englishPrefix + '1.2.410.200004.5.5.1.4.2'] = 'E-Tax(Corporation)';
oids[englishPrefix + '1.2.410.200004.5.5.1.4.4'] = 'User institution';
oids[englishPrefix + '1.2.410.200004.5.5.1.4.5'] = 'Special purpose(Corporation)';

//GPKI
oids[englishPrefix + '1.2.410.100001.2'] = 'GPKI Authentication policy';
oids[englishPrefix + '1.2.410.100001.2.1'] = 'Department';
oids[englishPrefix + '1.2.410.100001.2.1.1'] = 'Department';
oids[englishPrefix + '1.2.410.100001.2.1.2'] = 'Computer';
oids[englishPrefix + '1.2.410.100001.2.1.3'] = 'Special';
oids[englishPrefix + '1.2.410.100001.2.1.4'] = 'Public Department';
oids[englishPrefix + '1.2.410.100001.2.1.5'] = 'Public Computer';
oids[englishPrefix + '1.2.410.100001.2.1.6'] = 'Public Special';
oids[englishPrefix + '1.2.410.100001.2.2'] = 'Personal';
oids[englishPrefix + '1.2.410.100001.2.2.1'] = 'Personal';
oids[englishPrefix + '1.2.410.100001.2.2.2'] = 'Public Personal';

oids[englishPrefix + '1.2.410.100001.5.3.1.1'] = 'CA';
oids[englishPrefix + '1.2.410.100001.5.3.1.3'] = 'Personal';
oids[englishPrefix + '1.2.410.100001.5.3.1.5'] = 'Special';
oids[englishPrefix + '1.2.410.100001.5.3.1.7'] = 'Computer';
oids[englishPrefix + '1.2.410.100001.5.3.1.9'] = 'SSL';
//undefined
oids[englishPrefix + 'undefined'] = 'General';

// OCSP
oids['1.3.6.1.5.5.7.48.1'] = 'OCSP';
oids['OCSP'] = '1.3.6.1.5.5.7.48.1';

// VID
oids['1.2.410.200004.10.1.1.1'] = 'VID';
oids['VID'] = '1.2.410.200004.10.1.1.1';

// KISA
oids['1.2.410.200004.10.1.1'] = 'KISA_ID_DATA';
oids['KISA_ID_DATA'] = '1.2.410.200004.10.1.1';

// VID Random
oids['1.2.410.200004.10.1.1.3'] = 'Random';
oids['Random'] = '1.2.410.200004.10.1.1.3';

// Bank Name
const bankCD = (forge.pki.bankCD = forge.pki.bankCD || {});
//var bankCD= {};
bankCD['01'] = '한국은행';
bankCD['02'] = '산업은행';
bankCD['03'] = '기업은행';
bankCD['04'] = '국민은행';
bankCD['06'] = '국민은행';
bankCD['19'] = '국민은행';
bankCD['29'] = '국민은행';
bankCD['05'] = '외한은행';
bankCD['07'] = '수협은행';
bankCD['08'] = '수출입은행';

bankCD['10'] = '농협은행';
bankCD['11'] = '농협은행';
bankCD['12'] = '농협은행';
bankCD['13'] = '농협은행';
bankCD['14'] = '농협은행';
bankCD['15'] = '농협은행';
bankCD['16'] = '농협은행';
bankCD['17'] = '농협은행';

bankCD['20'] = '우리은행';
bankCD['22'] = '우리은행';
bankCD['24'] = '우리은행';
bankCD['83'] = '우리은행';
bankCD['84'] = '우리은행';

bankCD['21'] = '신한은행';
bankCD['26'] = '신한은행';
bankCD['28'] = '신한은행';
bankCD['88'] = '신한은행';

bankCD['23'] = 'SC은행';

bankCD['25'] = '하나은행';
bankCD['33'] = '하나은행';
bankCD['81'] = '하나은행';
bankCD['82'] = '하나은행';

bankCD['27'] = '한국씨티';
bankCD['36'] = '한국씨티';
bankCD['53'] = '한국씨티';

bankCD['31'] = '대구은행';
bankCD['32'] = '부산은행';

bankCD['34'] = '광주은행';
bankCD['35'] = '제주은행';
bankCD['37'] = '전북은행';
bankCD['39'] = '경남은행';

bankCD['46'] = '새마을금고';
bankCD['47'] = '새마을금고';
bankCD['85'] = '새마을금고';
bankCD['86'] = '새마을금고';

bankCD['48'] = '신협은행';
bankCD['49'] = '신협은행';

bankCD['50'] = '상호저축은행';
bankCD['51'] = '외국은행';
bankCD['54'] = 'HSBC은행';
bankCD['55'] = '도이치은행';
bankCD['56'] = '에이비엔암로은행';

bankCD['57'] = 'UFJ은행';
bankCD['58'] = '미즈호코퍼레이트은행';
bankCD['59'] = '미쓰비시도쿄UFJ은행';
bankCD['60'] = 'B.O.A';

bankCD['71'] = '우체국';
bankCD['72'] = '우체국';
bankCD['73'] = '우체국';
bankCD['74'] = '우체국';
bankCD['75'] = '우체국';

bankCD['76'] = '신용보증기금';
bankCD['77'] = '기술신용보증기금';
bankCD['95'] = '경찰청';
bankCD['91'] = '이니텍';

bankCD['99'] = '금융결제원';

//영문 은행명
bankCD[englishPrefix + '01'] = 'www.bok.or.kr'; // 영문없음 한국은행
bankCD[englishPrefix + '02'] = 'www.kdb.co.kr';
bankCD[englishPrefix + '03'] = 'www.kiupbank.co.kr';
bankCD[englishPrefix + '04'] = 'www.kbstar.com';
bankCD[englishPrefix + '06'] = 'www.kbstar.com';
bankCD[englishPrefix + '19'] = 'www.kbstar.com';
bankCD[englishPrefix + '29'] = 'www.kbstar.com';
bankCD[englishPrefix + '05'] = 'www.keb.co.kr';
bankCD[englishPrefix + '07'] = 'www.suhyup.co.kr';
bankCD[englishPrefix + '08'] = 'www.koreaexim.go.kr'; // 영문없음 수출입은행

bankCD[englishPrefix + '10'] = 'www.nonghyup.com';
bankCD[englishPrefix + '11'] = 'www.nonghyup.com';
bankCD[englishPrefix + '12'] = 'www.nonghyup.com';
bankCD[englishPrefix + '13'] = 'www.nonghyup.com';
bankCD[englishPrefix + '14'] = 'www.nonghyup.com';
bankCD[englishPrefix + '15'] = 'www.nonghyup.com';
bankCD[englishPrefix + '16'] = 'www.nonghyup.com';
bankCD[englishPrefix + '17'] = 'www.nonghyup.com';

bankCD[englishPrefix + '20'] = 'www.wooribank.com';
bankCD[englishPrefix + '22'] = 'www.wooribank.com';
bankCD[englishPrefix + '24'] = 'www.wooribank.com';
bankCD[englishPrefix + '83'] = 'www.wooribank.com';
bankCD[englishPrefix + '84'] = 'www.wooribank.com';

bankCD[englishPrefix + '21'] = 'www.shinhan.com';
bankCD[englishPrefix + '26'] = 'www.shinhan.com';
bankCD[englishPrefix + '28'] = 'www.shinhan.com';
bankCD[englishPrefix + '88'] = 'www.shinhan.com';

bankCD[englishPrefix + '23'] = 'www.scfirstbank.com';

bankCD[englishPrefix + '25'] = 'www.hanabank.com';
bankCD[englishPrefix + '33'] = 'www.hanabank.com';
bankCD[englishPrefix + '81'] = 'www.hanabank.com';
bankCD[englishPrefix + '82'] = 'www.hanabank.com';

bankCD[englishPrefix + '27'] = 'www.citibank.co.kr';
bankCD[englishPrefix + '36'] = 'www.citibank.co.kr';
bankCD[englishPrefix + '53'] = 'www.citibank.co.kr';

bankCD[englishPrefix + '31'] = 'www.daegubank.co.kr';
bankCD[englishPrefix + '32'] = 'www.pusanbank.co.kr';

bankCD[englishPrefix + '34'] = 'www.kjbank.com';
bankCD[englishPrefix + '35'] = 'www.e-jejubank.com';
bankCD[englishPrefix + '37'] = 'www.jbbank.co.kr';
bankCD[englishPrefix + '39'] = 'www.kyongnambank.co.kr';

bankCD[englishPrefix + '46'] = 'www.kfcc.co.kr'; // 영문 없음 새마을 금고
bankCD[englishPrefix + '47'] = 'www.kfcc.co.kr';
bankCD[englishPrefix + '85'] = 'www.kfcc.co.kr';
bankCD[englishPrefix + '86'] = 'www.kfcc.co.kr';

bankCD[englishPrefix + '48'] = 'www.cu.co.kr';
bankCD[englishPrefix + '49'] = 'www.cu.co.kr';

bankCD[englishPrefix + '50'] = 'www.fsb.or.kr'; // 영문 없음 상호저축은행
bankCD[englishPrefix + '51'] = '외국은행'; // 영문 없음 외국 은행 사이트 없음
bankCD[englishPrefix + '54'] = 'kr.hsbc.com';
bankCD[englishPrefix + '55'] = 'www.db.com';
bankCD[englishPrefix + '56'] = 'www.abnamro.com'; // 영문 없음 에이비엔암로은행

bankCD[englishPrefix + '57'] = 'www.ufjbank.co.jp'; // www.ufjbank.co.jp -> www.bk.mufg.jp 혹 명칭이 바뀌면서 코드 새로 받지는 않았는지?
bankCD[englishPrefix + '58'] = 'www.mizuhobank.co.jp'; // 영문 없음 미즈호코퍼레이트은행
bankCD[englishPrefix + '59'] = 'www.bk.mufg.jp'; // 영문 없음 미쓰비시도쿄UFJ은행
bankCD[englishPrefix + '60'] = 'www.bankofamerica.com'; // 영문 없음 B.O.A

bankCD[englishPrefix + '71'] = 'www.epost.go.kr'; // 영문 없음 새마을 금고
bankCD[englishPrefix + '72'] = 'www.epost.go.kr';
bankCD[englishPrefix + '73'] = 'www.epost.go.kr';
bankCD[englishPrefix + '74'] = 'www.epost.go.kr';
bankCD[englishPrefix + '75'] = 'www.epost.go.kr';

bankCD[englishPrefix + '76'] = 'www.kodit.co.kr'; // 영문 없음 신용보증기금
bankCD[englishPrefix + '77'] = 'www.kibo.or.kr'; // 영문 없음 기술신용보증기금
bankCD[englishPrefix + '95'] = 'www.police.go.kr'; // 영문 없음 경찰청
bankCD[englishPrefix + '91'] = 'www.initech.com';

bankCD[englishPrefix + '99'] = 'www.kftc.or.kr'; // 영문 없음 금융결제원
